import { lazy } from 'react';
import { FuseRouteItemType } from '@fuse/utils/FuseUtils';

const MovementYearOnYearPage = lazy(() => import('./MovementYearOnYearHorizontalPage'));

const path = 'reports/movement-yoy-horizontal';
const MovementYearOnYearRoute: FuseRouteItemType = {
	path: path,
	element: <MovementYearOnYearPage />,
	settings: {
		layout: {
			config: {
				navbar: {
					display: true
				},
				toolbar: {
					title: 'Year on Year Movement',
					helpName: 'Horizontal Movement Year on Year',
				},
				footer: {
					display: false
				},
				leftSidePanel: {
					display: false
				},
				rightSidePanel: {
					display: false
				}
			}
		}
	}
};

export default MovementYearOnYearRoute;
